import React, { useEffect, useState } from "react";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Page from "../components/page";
import List from "../components/list";
import icons from "../constants/icons";
import api from "../functions/api";
import config from "../configs";

const Home = () => {
  const [data, setData] = useState(null);
  const [searchParams] = useSearchParams();
  const { search: searchParam } = useParams();

  const navigate = useNavigate();

  let page = parseInt(searchParams.get("page") || 1);
  let search = searchParam && decodeURI(searchParam.replaceAll("-", " "));

  const pages =
    data?.totalPages === 1
      ? [1]
      : data?.totalPages === 2
      ? [1, 2]
      : page === 1
      ? [1, 2, 3]
      : [page - 1, page, data?.totalPages > page ? page + 1 : null];

  const categories = [
    // {
    //     title: "18+",
    // },
    {
      title: "NETFLIX",
    },
  ];

  const moreCategories = [
    {
      link: "amazon%20prime",
      title: "AMAZON PRIME",
    },
    {
      link: "disney",
      title: "DISNEY+ HOTSTAR",
    },
    {
      title: "SONYLIV",
    },
    {
      title: "ZEE5",
    },
    {
      title: "JIOCINEMA",
    },
    {
      title: "VOOT",
    },
    {
      title: "HOICHOI",
    },
    {
      title: "DISCOVERY",
    },
    {
      title: "BENGALI",
    },
    {
      title: "GUJARATI",
    },
    {
      title: "PUNJABI",
    },
    {
      title: "MARATHI",
    },
    // {
    //   title: "MARVEL CINEMATIC",
    // },
    // {
    //   title: "MOVIES COLLECTION",
    // },
  ];
  const getData = async () => {
    try {
      const response = await api.get(
        `/movies-list?page=${page}${search ? "&search=" + search : ""}`,
        search
      );
      setData(response);
      document.querySelector(".page")?.scrollTo(0, 0);
      window.scrollTo(0, 0);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    document.querySelector(".page")?.scrollTo(0, 0);
    window.scrollTo(0, 0);
    getData();
  }, [page, search]);

  return (
    <Page
      className="Home home-page"
      title={search ? `${search} - ${config.appName}` : config.homeTitle}
      description={!search && config.homeDescription}
      canonical={config.domain}
    >
      {!search && (
        <div className="categories">
          {[...categories, ...moreCategories]?.map((item, index) => (
            <Link
              to={`/category/${(item.link || item.title).replaceAll(" ", "-")}`}
              key={index}
              className="tags"
            >
              {item.title}
            </Link>
          ))}
        </div>
      )}

      <div className="search-bar">
        <img src={icons.search} className="search-icon" />
        <input
          placeholder="Search here..."
          className="searchInput"
          onChange={(e) =>
            navigate(
              !e.target.value
                ? "/"
                : `/search/${e.target.value.replaceAll(" ", "-")}`,
              { replace: true }
            )
          }
        />
      </div>

      {search && <h2 className="cat-name">{search.replaceAll("-", " ")}</h2>}

      <List data={data?.list} />

      <div className="pagination">
        {page > 1 && (
          <Link
            to={`${search ? `/search/${search}` : ""}${
              page - 1 == 1 ? "" : `?page=${page - 1}`
            }`}
            className="right"
          >
            <img src={icons.right} alt="Previous" className="rightIcon" />
          </Link>
        )}

        <div style={{ display: "flex", cursor: "pointer" }}>
          {pages.map((item, index) => {
            if (!item) return null;
            return (
              <Link
                to={
                  (search ? `/search/${search}` : "") +
                  (item === 1 ? "" : `?page=${item}`)
                }
                key={index}
                className={item === page ? "rightA" : "right"}
              >
                <div className={item === page ? "number active" : "number"}>
                  {item}
                </div>
              </Link>
            );
          })}
        </div>

        {data?.totalPages > page && (
          <Link
            to={`${search ? `/search/${search}` : ""}?page=${page + 1}`}
            className="right"
          >
            <img src={icons.left} alt="Next" className="rightIcon" />
          </Link>
        )}
      </div>

      <br />

      {!search && (
        <article>
          <h1 style={{ lineHeight: "35px" }}>
            The Evolution of Online Movie Download Platforms
          </h1>
          <p>
            The digital era has transformed the way people access entertainment.
            Gone are the days when audiences had to visit theaters or purchase
            DVDs to enjoy their favorite movies. Online platforms have made it
            convenient for users to stream or download movies directly to their
            devices. Among the popular names in this domain,{" "}
            <strong>Movierulz</strong> has gained significant attention for its
            extensive collection of films and web series.
          </p>
          <h4>Exploring the Content Variety</h4>
          <p>
            One of the standout features of movie downloading websites is their
            diverse catalog of content. From the latest Hollywood blockbusters
            to regional cinema, such platforms cater to a global audience. Fans
            of Bollywood can find their favorite stars' movies easily, while
            lovers of Hollywood thrillers can download the latest releases in
            high-definition. <strong>Movierulz</strong>, in particular, is known
            for hosting a vast array of content spanning multiple genres,
            languages, and industries, making it a hub for movie enthusiasts.
          </p>
          <p>
            In addition to movies, these platforms often include popular web
            series, documentaries, and short films. The ability to access such a
            broad spectrum of entertainment has made them a preferred choice for
            users who want everything in one place.
          </p>
          <h4>The Role of Technology</h4>
          <p>
            The rapid advancement of technology has played a crucial role in the
            rise of online movie platforms. With high-speed internet becoming
            more accessible, downloading large files has become quicker and
            easier. Platforms like <strong>Movierulz</strong> utilize these
            technological advancements to provide seamless downloading options
            for users. Additionally, many websites now offer content in multiple
            resolutions, from 480p to 4K, ensuring compatibility with various
            devices and internet speeds.
          </p>
          <p>
            Mobile devices have further amplified the convenience of movie
            downloading. Users can now store their favorite movies and shows on
            their smartphones or tablets, allowing them to enjoy entertainment
            on the go. This shift towards mobile-first content consumption has
            driven websites to optimize their platforms for smaller screens,
            ensuring a smooth user experience.
          </p>
          <h4>The Global Appeal</h4>
          <p>
            Movie downloading websites have a global appeal, thanks to their
            ability to cater to diverse audiences. While Hollywood and Bollywood
            dominate the scene, regional cinema from countries like South Korea,
            Japan, and Spain has also found a place on these platforms. This
            inclusivity has introduced viewers to different cultures and
            storytelling styles, broadening their horizons.
          </p>
          <p>
            For instance, <strong>Movierulz</strong> is known for its
            wide-ranging collection of regional films, including Tamil, Telugu,
            Malayalam, and Kannada movies. Fans of these industries often rely
            on such platforms to access their favorite content, especially when
            it's not available on mainstream streaming services.
          </p>
          <h4>The Popularity of Web Series</h4>
          <p>
            In recent years, web series have emerged as a dominant form of
            entertainment, offering episodic content that keeps viewers hooked.
            Movie downloading websites have adapted to this trend by including
            popular web series in their catalogs. These series, often produced
            by leading streaming platforms, cater to niche audiences with unique
            storylines and characters.
          </p>
          <p>
            Platforms like <strong>Movierulz</strong> provide users with the
            opportunity to explore web series from around the world, ensuring
            they never miss out on trending shows. From crime dramas to romantic
            comedies, the variety of content available is staggering.
          </p>
          <h4>User-Friendly Features</h4>
          <p>
            A major factor contributing to the popularity of movie downloading
            platforms is their user-friendly design. These websites often
            feature intuitive layouts that make navigation simple, even for
            first-time users. Categories and filters allow viewers to find
            specific genres, languages, or release years quickly.
          </p>
          <p>
            <strong>Movierulz</strong>, for example, has a straightforward
            interface that lets users browse and download content with ease. The
            platform's search functionality ensures that users can locate their
            favorite movies or shows in seconds, making it a go-to destination
            for entertainment seekers.
          </p>
          <h4>The Demand for High-Quality Content</h4>
          <p>
            As viewers become more discerning, the demand for high-quality
            content continues to grow. Movie downloading platforms have
            responded by offering content in HD and even 4K resolution. This
            ensures that users can enjoy a cinematic experience from the comfort
            of their homes.
          </p>
          <p>
            Additionally, these platforms often provide multiple download links
            and file sizes, catering to users with varying internet speeds and
            storage capacities. <strong>Movierulz</strong> is known for offering
            high-quality downloads, allowing viewers to experience their
            favorite movies and shows in the best possible resolution.
          </p>
          <h4>The Impact of Social Media</h4>
          <p>
            Social media has played a significant role in the popularity of
            movie downloading platforms. Users often share recommendations,
            reviews, and download links on platforms like Twitter, Facebook, and
            Reddit. This word-of-mouth promotion has helped websites like{" "}
            <strong>Movierulz</strong> reach a wider audience.
          </p>
          <p>
            Fan communities also contribute to the growth of these platforms by
            discussing new releases and creating excitement around upcoming
            films and shows. This online buzz often drives traffic to movie
            downloading websites, ensuring a steady stream of users.
          </p>
          <h4>The Future of Movie Downloading Platforms</h4>
          <p>
            As technology continues to evolve, movie downloading platforms are
            expected to become even more sophisticated. Artificial intelligence
            and machine learning could be used to personalize content
            recommendations, ensuring that users discover movies and shows that
            align with their tastes.
          </p>
          <p>
            Additionally, the rise of virtual reality (VR) and augmented reality
            (AR) could open up new possibilities for immersive entertainment
            experiences. While platforms like <strong>Movierulz</strong>{" "}
            currently focus on traditional content, the future may see them
            exploring innovative ways to deliver movies and shows to their
            users.
          </p>
          <h4>Conclusion</h4>
          <p>
            Movie downloading platforms have revolutionized the way people
            access entertainment. With their vast catalogs, high-quality
            downloads, and user-friendly features, they have become an integral
            part of the digital entertainment landscape.{" "}
            <strong>Movierulz</strong> stands out as a prime example of such
            platforms, offering a diverse range of content that caters to
            audiences worldwide.
          </p>
          <p>
            As these platforms continue to evolve, they are likely to shape the
            future of entertainment consumption, providing users with even more
            convenient and immersive ways to enjoy their favorite movies and
            shows.
          </p>
        </article>
      )}

      {/* {search && window?.location?.href?.includes("category") && (
        <article>
          <p>
            {search}, the heart of cinema, offers a wide variety of movie
            genres, catering to audiences of all ages and preferences. With its
            vibrant storytelling, melodious music, and iconic stars, Bollywood
            films span multiple categories, each unique in its own charm
          </p>
        </article>
      )} */}
    </Page>
  );
};

export default Home;
